import { RiMailSendLine } from "react-icons/ri";
import styles from "./ContactForm.module.css";
import { useState } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
import Input from "../Input/Input";
import { useMemo } from "react";

const initialMessageInfoState = {
  user_name: "",
  user_email: "",
  message_text: "",
};

export const ContactForm = () => {
  const [messageInfo, setMessageInfo] = useState(initialMessageInfoState);
  const [isSending, setIsSending] = useState(false);
  const sendEmailMessageHandler = async (e) => {
    e.preventDefault();
    const { user_name, user_email, message_text } = messageInfo;
    try {
      setIsSending(true);
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_KEY,
        process.env.REACT_APP_EMAILJS_TEMPLATE_KEY,
        { user_name, user_email, message: message_text },
        { publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY }
      );
      toast(
        "Your message has been sent successfully. Thank you for reaching out!",
        { type: "success", bodyStyle: { fontSize: "13px" } }
      );
      setMessageInfo(initialMessageInfoState);
    } catch (err) {
      console.log({ err });
      toast("Failed to send your message. Please try again later.", {
        type: "error",
        bodyStyle: { fontSize: "13px" },
      });
    } finally {
      setIsSending(false);
    }
  };

  const onChangeHandler = (e) => {
    const { value, name: key } = e.target;
    setMessageInfo((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const contactInputs = useMemo(() => {
    return [
      {
        label: "Full Name",
        name: "user_name",
        value: messageInfo.user_name,
        isTextArea: false,
      },
      {
        label: "Email Address",
        name: "user_email",
        value: messageInfo.user_email,
        isTextArea: false,
      },
      {
        label: "Message",
        name: "message_text",
        value: messageInfo.message_text,
        isTextArea: true,
      },
    ];
  }, [messageInfo]);
  return (
    <form onSubmit={sendEmailMessageHandler}>
      {contactInputs.map((item) => (
        <Input
          label={item.label}
          name={item.name}
          onChange={onChangeHandler}
          value={item.value}
          isTextArea={item.isTextArea}
          key={item.name}
        />
      ))}
      <button type="submit" className={styles.btn} disabled={isSending}>
        {isSending ? "Sending..." : "Send Message"}
        <RiMailSendLine className={styles.icon} />
      </button>
    </form>
  );
};
